.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
}

.tile,
.skel {
  position: relative;
  aspect-ratio: 9 / 16;
  overflow: hidden;
  background: var(--surface-2);
}

.tile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--t-slow) var(--ease), filter var(--t-med);
}

.tile:hover img {
  transform: scale(1.04);
  filter: brightness(1.08);
}

.noThumb {
  position: absolute;
  inset: 0;
  background: linear-gradient(160deg, var(--surface-3), var(--surface-1));
}

.views {
  position: absolute;
  left: 6px;
  bottom: 6px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 12px;
  font-weight: 700;
  text-shadow: 0 1px 4px rgb(0 0 0 / 0.8);
}
